import {
  mkLogoTrackAttrs,
  mkSuggestionBtnTrackAttrs,
} from '@/analytics/props/home';
import { Suggestion } from '@/components/chat/constants/SuggestedQueries';
import MessageBar from '@/components/chat/MessageBar';

import { Box, Grid } from '@mui/material';
import styled from 'styled-components';

type ChatLayoutContentProps = {
  handleSendMessage: (text: string) => Promise<void>;
  onFilesChanged?: (files: File[]) => void;
  handleShowSuggestion: (
    event: React.MouseEvent<HTMLAnchorElement>,
    suggestion: string,
  ) => void;
  isMessageBarPending: boolean;
  suggestions: Suggestion[];
  tagLine: JSX.Element | null;
  toolLogo: JSX.Element;
};

export const ChatLayoutContent = ({
  toolLogo,
  tagLine,
  handleSendMessage,
  onFilesChanged,
  isMessageBarPending,
  suggestions,
  handleShowSuggestion,
}: ChatLayoutContentProps) => {
  return (
    <>
      <Box>
        <LogoContainer {...mkLogoTrackAttrs()}>{toolLogo}</LogoContainer>
      </Box>

      {tagLine}

      <MessageBar
        onSend={handleSendMessage}
        onFilesChanged={onFilesChanged}
        isPending={isMessageBarPending}
        focusOnLoad
      />

      <Grid
        container
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1}
        sx={{ mt: '8px' }}
      >
        {suggestions.map((suggestion, index) => (
          <Grid item key={suggestion.id}>
            <SuggestedPrompt
              href="#"
              onClick={(e) => handleShowSuggestion(e, suggestion.prompt)}
              {...mkSuggestionBtnTrackAttrs({
                index,
                visibleSuggestionCount: suggestions.length,
                label: suggestion.label,
                prompt: suggestion.prompt,
              })}
            >
              {suggestion.icon && <suggestion.icon />}
              {suggestion.label}
            </SuggestedPrompt>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

const LogoContainer = styled('span')`
  display: inline-block;
  svg {
    width: 80%;
    height: auto;
    @media (min-width: 600px) {
      width: 100%;
    }
  }
`;

const SuggestedPrompt = styled('a')`
  align-items: center;
  border: 1px solid rgba(250, 242, 233, 0.2);
  border-radius: 6px;
  color: ${({ theme }) => theme.palette.secondary.light};
  display: flex;
  font-size: ${({ theme }) => theme.font.size.sm};
  gap: ${({ theme }) => theme.spacing(0.5)};
  line-height: ${({ theme }) => theme.spacing(3)};
  margin-bottom: 0;
  padding: ${({ theme }) => theme.spacing(0.75, 1.25)};

  :hover {
    color: ${({ theme }) => theme.color['green-60'].hex};
  }

  & .MuiSvgIcon-root {
    color: ${({ theme }) => theme.palette.secondary.light};
    height: ${({ theme }) => theme.spacing(2.5)};
  }
`;
